import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import CompetitionModal from "@/Modals/WebDataManagement/MasterData/Competitions/Modal";
import MasterDataBaseTable from "../MasterDataBaseTable";
import React from "react";
import { columns } from "./Columns";
import { competitionsMasterDataApi } from "@/apis/apis";
import { useFilters } from "./Filters";

export default function CompetitionsPage() {
  const filters = useFilters();

  return (
    <MasterDataBaseTable
      label="Competition"
      apiURL={competitionsMasterDataApi}
      columns={columns()}
      filters={filters}
      ModalComponent={CompetitionModal}
      importData={BASE_IMPORT_DATA.COMPETITIONS}
      enableStatus={false}
      enableSortData={true}
    />
  );
}
